import * as React from 'react';
// import { lazyInject } from '../../../services/inversify';
// import { TriggerService } from '../../../core/trigger/trigger_service';
import { IDs } from '../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface BeraterzuordnungProps extends React.ClassAttributes<any> {
    data: any;
}

interface BeraterzuordnungState {
    formExternerBerater: boolean;
}

export class Beraterzuordnung extends React.Component<BeraterzuordnungProps, BeraterzuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            formExternerBerater: false
        };
    }

    render(): JSX.Element {

        const customFormatter = (key: string, value: any, data: any, row: any) => {
            if (value === undefined || value === null) {
                return '';
            }
            return value;
        };

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_BERATERZUORDNUNG}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    formLayout={'flowV2'}
                    customClass={'Custom-ETA'}
                    showColumnsHelp={true}
                    customFormatter={customFormatter}
                />
            </div>
        );
    }
}
